import { ErrorHandler, NgModule, inject, provideAppInitializer } from '@angular/core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import * as Sentry from '@sentry/angular';
import { fetchAndActivate, RemoteConfig } from 'firebase/remote-config';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { FirebaseToken } from './core/firebase.module';
import { SharedModule } from './features/shared/shared.module';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { version } from '../environments/version';
import { Router } from '@angular/router';

export const TranslateLoaderFactory = (http: HttpClient) =>
  new TranslateHttpLoader(http, './assets/locale/', '.json?v=' + version.epoch);

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    AppRoutingModule,
    CoreModule,
    SharedModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: TranslateLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    provideAppInitializer(() => {
      const initializerFn = ((
        remoteConfig: RemoteConfig,
        _sentryTraceService: Sentry.TraceService,
      ) => {
        // Must return a function that returns a promise
        // See: https://stackoverflow.com/a/56165556/379923
        return async () => {
          await Promise.all([fetchAndActivate(remoteConfig)]);
        };
      })(inject(FirebaseToken.RemoteConfig), inject(Sentry.TraceService));

      return initializerFn();
    }),
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
